import { render } from "./singleType.vue?vue&type=template&id=2f960386&scoped=true"
import script from "./singleType.vue?vue&type=script&lang=js"
export * from "./singleType.vue?vue&type=script&lang=js"

import "./singleType.vue?vue&type=style&index=0&id=2f960386&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f960386"]])

export default __exports__